import { clearAllFiltersContextMenuObject } from "../../../tradeActionSummary/contextMenusRightClick/genericContextMenuItems";

export const defaultColDefTradeCreation = {
  suppressHeaderMenuButton: true,

  filter: true,
  cellStyle: { borderRight: "Var(--ag-grid-cubeCustom-cell-border)" },
  enableRowGroup: true,
  // enableCellChangeFlash: true, // Turned off individual cell flashing as the whole row will always flash if an update is made.
  // filterParams: {
  //   applyMiniFilterWhileTyping: true,
  //   buttons: ["reset"],
  // },
  filterParams: {
    buttons: ["reset"],
  },
  mainMenuItems: [
    "sortAscending",
    "sortDescending",
    "sortUnSort",
    "separator",
    "pinSubMenu",
    "separator",
    "autoSizeThis",
    "separator",
    "rowGroup",
    // "rowUnGroup", - can't access this button.
    "separator",
    "resetColumns",
    { ...clearAllFiltersContextMenuObject },
  ],
};
